export default "__VITE_ASSET__eMHxmjA3__"